export const CURRENCY_CODES = [
  'PLN', 'USD', 'GBP', 'EUR'
]
